import axios from 'axios'
import router from '../../router'

export default {
    state : { 
        baseUrl:process.env.API_URL,
        user:{}
        },
    getters : {
        user:(state) =>{
            return state.user
        }
     },
    mutations : { 
        user(state, data){
            state.user = data
        }
     },
    actions : { 

        setLanguage({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/setLanguage`,form)
                .then(response => {
                    console.log("setLanguage action response.data")
                    console.log(response.data)
                    resolve(response.data)
                })
                .catch(e => {
                    console.log("setLanguage action error")
                    console.log(e)
                    reject()
                })
            })
        },

        authenticateUser_2fa({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/authenticateUser_2fa`,form)
                .then(response => {
                    console.log("authenticateUser_2fa action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        commit('user',response.data)
                        // BUradaki gibi
                        localStorage.setItem('name',response.data.content.name)
                        localStorage.setItem('organization_name',response.data.content.organization_name)
                        localStorage.setItem('lang', response.data.content.language)
                        
                    }

                    resolve(response.data)
                    
                })
                .catch(e => {
                    console.log("authenticateUser_2fa action error")
                    console.log(e)
                    reject()
                })
            })
        },
        requestPasswordReset({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/requestPasswordReset`,form)
                .then(response => {
                    console.log("requestPasswordReset action response.data")
                    console.log(response.data)
                    
                    resolve(response.data)
                    
                })
                .catch(e => {
                    console.log("requestPasswordReset action error")
                    console.log(e)
                    reject()
                })
            })
        },
        changePassword({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/changePassword`,form)
                .then(response => {
                    console.log("response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        Notification.open({
                            message: 'Your password has been changed successfully.',
                            type: 'is-success',
                            duration:5000
                        })
                        resolve("SUCCESS")
                    }else if(response.data.status.code=='130'){
                        Notification.open({
                            message: "Sorry, current password does not match!",
                            type: 'is-warning',
                            duration:7000
                        })
                        resolve('OLD_PASSWORD_NOT_MATCH')
                    }else{
                        Notification.open({
                            message: 'Sorry, change password request was unsuccessful!',
                            type: 'is-danger',
                            duration:5000
                        })
                        resolve('AUTH_ERROR')
                    }
                })
                .catch(e => {
                    console.log(e)
                    reject()
                })
            })
        },
        resetPassword({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/resetPassword`,form)
                .then(response => {
                    console.log("resetPassword action response.data")
                    console.log(response.data)

                    resolve(response.data)
                })
                .catch(e => {
                    console.log("resetPassword action error")
                    console.log(e)
                    reject()
                })
            })
        },
        logoutUser({commit,state}){
            return new Promise((resolve, reject) => {
                axios.get(`${state.baseUrl}/logout`)
                .then(response => {
                    console.log("logoutUser action response.data")
                    console.log(response.data)
                    resolve(response.data)
                    if(response.data.status.code=='0'){
                        localStorage.removeItem('name')
                        localStorage.removeItem('organization_name')
                        router.push('/login')
                    }
                })
                .catch(e => {
                    console.log("logoutUser action error")
                    console.log(e)
                    reject()
                })
            })
        },
        initialize_2fa({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/initialize_2fa`,form)
                .then(response => {
                    console.log("initialize_2fa action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                        //  commit('user',response.data)
                        // // BUradaki gibi
                        //  localStorage.setItem('name',response.data.content.name)
                        //  localStorage.setItem('organization_name',response.data.content.organization_name)
                        //  localStorage.setItem('lang', response.data.content.language)
                        resolve(response.data)
                    }

                    resolve(response.data)
                    
                })
                .catch(e => {
                    console.log("initialize_2fa action error")
                    console.log(e)
                    reject()
                })
            })
        },
        activate_2fa({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/activate_2fa`,form)
                .then(response => {
                    console.log("activate_2fa action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                         commit('user',response.data)
                        // BUradaki gibi
                         localStorage.setItem('name',response.data.content.name)
                         localStorage.setItem('organization_name',response.data.content.organization_name)
                         localStorage.setItem('lang', response.data.content.language)
                        // resolve(response.data)
                    }

                    resolve(response.data)
                    
                })
                .catch(e => {
                    console.log("initialize_2fa action error")
                    console.log(e)
                    reject()
                })
            })
        },

        authenticateUser_2fa_finalize({commit,state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/authenticateUser_2fa_finalize`,form)
                .then(response => {
                    console.log("authenticateUser_2fa_finalize action response.data")
                    console.log(response.data)
                    if(response.data.status.code=='0'){
                         commit('user',response.data)
                        // BUradaki gibi
                         localStorage.setItem('name',response.data.content.name)
                         localStorage.setItem('organization_name',response.data.content.organization_name)
                         localStorage.setItem('lang', response.data.content.language)
                        // resolve(response.data)
                    }

                    resolve(response.data)
                    
                })
                .catch(e => {
                    console.log("authenticateUser_2fa_finalize action error")
                    console.log(e)
                    reject()
                })
            })
        },
     }
}


// WEBPACK FOOTER //
// ./src/store/userGateway/user.js